function resetVariables(attributeList) {
    attributeList.forEach(attribute => {
        if (attribute && attribute.setter) {
            attribute.setter(attribute.resetValue || '');
        }
    });
}

export default { resetVariables };
